<template>
  <div class="card maadi-dark-card">
    <div class="card-header d-flex">
      <div>
        <div style="font-weight: 500" class="d-flex align-items-center">
          {{ activity.subject }}
          <i v-if="activity.involves_top_70_member" class="fas fa-star ml-2" v-b-tooltip.hover title="Involved Top 70 Member"></i>
          <div class="ml-3">
            <router-link :to="'/activity/' + activity.id">
              <i class="fas fa-arrow-circle-right"></i>
            </router-link>
          </div>
        </div>
        <div style="font-weight: 300">
          Participants: {{ accountsInvolvedTooltip }}
        </div>
      </div>
      <div class="ml-auto" style="font-weight: 300">
        <div>{{ activity.start_date | formatDate }}</div>
        <div class="text-right">{{ activity.user_name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityAPI from '../../api/activity'
export default {
  name: '',
  props: ['activity'],
  data: function () {
    return {
      isLoading: false,
      activityType: [
        {text: '', value: null},
        {text: 'Meeting', value: 'Meeting'},
        {text: 'Referrals', value: 'Referrals'},
        {text: 'Renewals', value: 'Renewals'},
        {text: 'Advocacy ', value: 'Advocacy'},
        {text: 'Invitation', value: 'Invite'},
        {text: 'Testimonial', value: 'Testimonial'},
        {text: 'Content', value: 'Content'},
        {text: 'Sponsorship', value: 'Sponsorship'},
        {text: 'COVID-19', value: 'COVID-19'}
      ],
      initiativeTypes: [
        {text: '', value: null},
        {text: 'Medical Alley Starts', value: 'Medical Alley Starts'},
        {text: 'HR & Talent', value: 'HR & Talent'},
        {text: 'Supply Chain', value: 'Supply Chain'},
        {text: 'International Efforts', value: 'International Efforts'}
      ],
      reminder: {}
    }
  },
  methods: {
    save () {
      this.isLoading = true
      ActivityAPI.updateActivity(this.activity.id, this.activity)
        .then(result => {
          this.isLoading = false
        })
    },
    addReminder () {
      ActivityAPI.addReminder(this.activity.id, this.activity)
        .then(result => {
        })
    }
  },
  computed: {
    accountsInvolvedRow: function () {
      if (this.activity.accounts.length === 0) {
        return
      }
      if (this.activity.accounts.length === 1) {
        return this.activity.accounts[0]
      }
      return this.activity.accounts[0] + '...'
    },
    accountsInvolvedTooltip () {
      let returnString = ''

      for (let i = 0; i < this.activity.accounts.length; i++) {
        let account = this.activity.accounts[i]
        returnString += account
        if (this.activity.accounts.length !== (i + 1)) {
          returnString += ', '
        }
      }
      return returnString
    }
  },
  mounted () {
    this.activity.create_reminder = 0
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/activities/SingleActivityInList.vue